"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var React = __importStar(require("react"));
var react_1 = require("react");
var react_query_1 = require("react-query");
var app_1 = __importDefault(require("../../../../bundler/app"));
var flatten_add_ons_1 = __importDefault(require("../../../../bundler/flatten-add-ons"));
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var loading_modal_1 = __importDefault(require("../../../components/loading-modal"));
var update_subscription_1 = require("../../../mutations/update-subscription");
var get_bundle_1 = require("../../../queries/get-bundle");
var utils_1 = require("../../../utils");
exports.default = (function (_a) {
    var _b;
    var existingBundle = _a.existingBundle, productId = _a.productId, subscriptionId = _a.subscriptionId, directStep = _a.directStep, subscriptionBaseName = _a.subscriptionBaseName, subscriptionUrlLocation = _a.subscriptionUrlLocation, preSelectedBundleType = _a.preSelectedBundleType, onSubscriptionUpdated = _a.onSubscriptionUpdated;
    var nextChargeDate = (0, date_fns_1.format)((0, date_fns_1.parseISO)(existingBundle.subscription.next_charge_scheduled_at), 'yyyy-MM-dd');
    var province = ((_b = existingBundle.address) === null || _b === void 0 ? void 0 : _b.province) || '';
    var _c = (0, react_query_1.useQuery)(['getBundleData', nextChargeDate, province], function () {
        return (0, api_1.getSubscriptionAPIClient)().request(get_bundle_1.GET_BUNDLE, {
            productId: productId,
            nextChargeDate: nextChargeDate,
            province: province,
            useInventoryMaster: window.accountApp.settings.useInventoryMaster || false,
        });
    }), bundleData = _c.data, isLoading = _c.isLoading;
    (0, react_1.useEffect)(function () {
        window.location.href = "".concat(subscriptionUrlLocation, "/").concat(subscriptionId, "/").concat(directStep);
    }, [directStep]);
    var _d = __read((0, react_1.useState)(false), 2), isUpdatingSubscription = _d[0], setIsUpdatingSubscription = _d[1];
    var callout = (0, callout_1.useCallout)().callout;
    var queryClient = (0, react_query_1.useQueryClient)();
    var _e = (0, react_query_1.useMutation)("updateSubscription", function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_subscription_1.UPDATE_SUBSCRIPTION, variables); }, {
        onSuccess: function (updatedData) { return __awaiter(void 0, void 0, void 0, function () {
            var updatedSubscriptionId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updatedSubscriptionId = updatedData.updateSubscription.subscription.id;
                        if (!(subscriptionId !== updatedSubscriptionId)) return [3 /*break*/, 2];
                        // only need to change the window location if the subscription id changed, like when diaper size changes
                        return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                    case 1:
                        // only need to change the window location if the subscription id changed, like when diaper size changes
                        _a.sent();
                        window.location.href = "".concat(subscriptionUrlLocation, "/").concat(updatedSubscriptionId);
                        return [3 /*break*/, 4];
                    case 2: 
                    // if the subscription id doesn't change, we can just update the subscription in the cache in place
                    return [4 /*yield*/, queryClient.setQueryData('getCustomerSubscriptions', function (data) { return (0, update_subscription_1.updateSubscriptionCache)(data, updatedData); })];
                    case 3:
                        // if the subscription id doesn't change, we can just update the subscription in the cache in place
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        callout.success('Successfully Updated Bundle! (Refresh page to reflect pricing changes)');
                        return [2 /*return*/];
                }
            });
        }); },
    }), updateSubscription = _e.mutateAsync, error = _e.error;
    if (isLoading) {
        return (React.createElement("div", { className: 'grid-container text-center' },
            React.createElement("div", { className: 'margin-vertical-4' }, "Loading...")));
    }
    var bundle = bundleData === null || bundleData === void 0 ? void 0 : bundleData.getBundle;
    var bundlerApp = window.bundlerApp;
    if (!bundle || !bundlerApp) {
        return React.createElement("div", null, "Error. Please try again later.");
    }
    var processFinalSubmit = function () { return function (updatedBundle) { return __awaiter(void 0, void 0, void 0, function () {
        var itemUpdates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsUpdatingSubscription(true);
                    itemUpdates = (0, utils_1.convertItemsToItemUpdateInputs)(updatedBundle);
                    return [4 /*yield*/, updateSubscription({ itemUpdates: itemUpdates, subscriptionId: subscriptionId })];
                case 1:
                    _a.sent();
                    if (onSubscriptionUpdated)
                        return [2 /*return*/, onSubscriptionUpdated()];
                    return [2 /*return*/];
            }
        });
    }); }; };
    return (React.createElement(React.Fragment, null,
        React.createElement(loading_modal_1.default, { error: error, isLoading: isUpdatingSubscription }),
        React.createElement(app_1.default, __assign({ basename: existingBundle ? "".concat(subscriptionBaseName, "/").concat(existingBundle.subscription.id) : undefined, customerCanChooseWipeslessSizes: bundlerApp.customerCanChooseWipeslessSizes, discountAddOnsPerLimit: bundlerApp.discountAddOnsPerLimit, variantIdsMaxQty: bundlerApp.variantIdsMaxQty, existingBundle: existingBundle, hideLeft: true, processFinalSubmit: processFinalSubmit(), skipSteps: ['select-add-ons', 'select-frequency'], steps: bundlerApp.steps, mainProduct: bundle.mainProduct, mainTrainingPantsProduct: bundle.mainTrainingPantsProduct, mainRcBundleProduct: bundlerApp.mainRcBundleProduct }, bundle, { enableNighttimeDiapers: bundlerApp.enableNighttimeDiapers, enableTrainingPants: bundlerApp.enableTrainingPants, addOns: (0, flatten_add_ons_1.default)(bundle.addOns || []), autoAddOns: (0, flatten_add_ons_1.default)(bundle.autoAddOns || []), discountAddOns: (0, flatten_add_ons_1.default)(bundle.discountAddOns || []), directStep: directStep, preSelectedBundleType: preSelectedBundleType, shippingIntervalUnitType: bundle.shippingIntervalUnitType }))));
});
